<div class="dashboardTable" style="margin: 5px;">
    <div class="heading-h1 mb-3">
        {{ "Component Details" | translate }}
        <span >
            {{ "for" | translate }} {{ vendorDetails?.Vendor_Name }}</span>
    </div>

    <p-table [value]="vendorDetailList" [rows]="10" [paginator]="false"
        [globalFilterFields]="[ 'programmeName', 'category', 'component', 'sizePrice', 'price', 'cmlSerialNo','cmlValidity','gstAmount','gstRate','calculatedPrice','Action']"
        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}</th>
                <th>{{'MI_SYSTEM'| translate}}</th>
                <th>{{'COMPONENT_CATEGORY'| translate}}</th>
                <th>{{'COMPONENT'| translate}}</th>
                <th>{{'COMPONENT_SIZE'| translate}}</th>
                <th>{{'PRICE'| translate}}</th>

                <th>{{'CML_SERIAL_NO'| translate}}</th>
                <th>{{'CML_VALIDITY'| translate}}</th>
                <th>{{'CML_CERTIFICATE'| translate}}</th>
                

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
            <tr>
                <td>{{rowIndex + 1}}</td>
                <!-- <td>{{product.vendor}}</td> -->
                <td>{{product.Program_Name}}</td>
                <td>{{product.Component_Cat}}</td>
                <td>{{product.Component}}</td>
                <td>{{product.Component_Size}}</td>
                <td>{{product.Price | currency: 'INR'}}</td>

                <td>{{product.CML_SrNo}}</td>
                <td>{{product.CML_Validity}}</td>
                <td>
                    <a *ngIf="product?.CML_Certificate" style="cursor: pointer" [href]="
                        product?.CML_Certificate
                    " target="_blank">{{'VIEW_DOC' | translate}}</a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{vendorDetailList ?
                    vendorDetailList.length : 0 }} {{'RECORDS_ADDED'| translate}}
                </p>
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7">No Data found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>